import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[idpStickyNavbar]',
  exportAs: 'idpStickyNavbar',
  standalone: true
})
export class IdpStickyNavbarDirective {
  reached = false;
  private stickyThreshold: number | null = null;

  constructor(public elementRef: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    this.updateThreshold();
    this.updateReachedState();
  }

  private updateThreshold(): void {
    if (!this.reached && this.stickyThreshold === null) {
      this.stickyThreshold =
        this.elementRef.nativeElement.getBoundingClientRect().top +
        window.scrollY -
        20;
    }
  }

  private updateReachedState(): void {
    if (this.stickyThreshold === null) return;
    this.reached = window.scrollY >= this.stickyThreshold;
    if (!this.reached) {
      this.stickyThreshold = null;
    }
  }
}
